<template>
    <section class="" >
        <el-dialog :title="title" :visible.sync="show01"  :close-on-click-modal="false" append-to-body="true">
        <el-form :model="form" :rules="rules" ref="ruleForm">

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="客户编号"  prop="Num">
                        <el-input v-model="form.Num" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户" prop="Name">
                        <el-input v-model="form.Name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="负责人"  prop="Manager">
                        <el-input v-model="form.Manager"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系电话"  prop="Phone">
                        <el-input v-model="form.Phone"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="form.Comment"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show01 = false">取 消</el-button>
            <el-button type="primary" @click="editFuc('NEW')" v-if="title=='新增客户'">确 定</el-button>
            <el-button type="primary" @click="editFuc()" v-else>确 定</el-button>
        </div>
    </el-dialog>

        <div class=" ml30 mr30" >
            <!--记录查询页 s-->
                <div class=" mb15 row flex-start">
                    <div class="row flex-start"><div>场地名称：</div>
                    <el-select ref="selectValue1" v-model="optionValue" @change="optionValueChange"  filterable placeholder="请选择" class="mr25">
                        <el-option
                                v-for="item in optionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        />
                    </el-select>
                    </div>
                </div>

                <div class="row flex-between mt15 mb15">
                    <div class="row flex-start">
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onEdit('new')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">新增</div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onEdit()" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">编辑</div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="editFuc('ENABLE')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">启用</div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="editFuc('DISABLE')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">禁用</div>
                    </div>
                </div>


                <template>
                    <el-table  v-loading = "isLoading"  element-loading-background = "rgba(255, 255, 255, .5)"  :element-loading-text = "loadText"  element-loading-spinner = "el-icon-loading"  :height="570"  :data="recoData.list"    :row-style="rowStyle"  @row-click="changeCurrentRow">
                        <el-table-column min-width="290"
                                prop="Num"
                                label="编号">
                        </el-table-column>
                        <el-table-column  min-width="200"
                                prop="Name"
                                label="客户名称">
                        </el-table-column>
                        <el-table-column
                                prop="Manager"
                                label="联系人">
                        </el-table-column>
                        <el-table-column width="120"
                                prop="Phone"
                                label="联系电话">
                        </el-table-column>
                        <el-table-column
                                prop="Comment"
                                label="备注">
                        </el-table-column>
                        <el-table-column
                                prop="Valid"
                                label="启用/禁用">

                            <template slot-scope="scope">
                                <span v-if="scope.row.Valid == 1" class="green_text">已启用</span>
                                <span v-if="scope.row.Valid == 0" class="red_text">已禁用</span>
                            </template>
                        </el-table-column>
                    </el-table>
                     <div class="row flex-between">
                         <div></div>
                         <div class="row flex-start font12">
                             <el-pagination background layout="total,sizes,prev, pager, next"     :page-size="recoData.recParams.page_size"  :page-sizes="[10,20,30,40,50,100,200,500,1000,2000]" :total="recoData.total"  popper-class='select_bottom'
                                           v-model:currentPage="recoData.recParams.page" v-model:page-size="recoData.recParams.page_size"
                                           @current-change="handleCurrentChange" @size-change="handleSizeChange" style="margin: 20px 0 20px 0;" />
                         </div>
                     </div>
                </template>
            <!--记录查询页 e-->



        </div>
    </section>
</template>

<script>
    import axios from "axios";
    import { showLoading, hideLoading } from '../utils/common.js';
    import  {checktel}  from '../utils/date.js';

    export default {
        data() {
            return {
                optionList: [],
                optionValue: '',
                user: JSON.parse(window.localStorage.getItem('user')),
                isLoading:false,//表格加载
                loadText:'正在加载…请耐心等待',
                loadText1:'正在加载…请耐心等待',
                loadText2:'数据比较多正在加载…请耐心等待',
                show01:false,//编辑弹窗
                form:{Name:''},
                title:'编辑客户',
                rules: {
                  Name:{ required: true, message: '请输入客户', trigger: 'blur' },
                  Phone:{ required: true, message: '请输入联系电话', trigger: 'blur' },
                  Manager:{ required: true, message: '请输入负责人', trigger: 'blur' }
                },
                recoData:{
                    currentRowId:'',//当前选中行的id
                    list:[],//表格list
                    total:0,//表格toal
                    keywords:'',
                    recParams:{
                        machine_code:'',
                        page_size:10,
                        page:1,
                    },
                }
            }
        },

        mounted: function () {
            this.resetData()
  		    this.getoptionList()
        },

        methods: {
//记录查询页 s


        optionValueChange(e){
                    this.onRefresh2()
        },
         resetData() {
            this.recoData.currentRowId=''
            this.recoData.list=[];
            this.recoData.total=0;
            this.recoData.keywords='';
            this.recoData.recParams.page=1;
            this.recoData.recParams.page_size=10;
        },
         onRefresh2() {
            this.resetData()
            this.getRecoredList()
         },


handleClose () {
      //this.$refs.ruleForm.resetFields()
    },
    handleSave () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.editFuc()
        } else {
          console.log('输入错误')
        }
      })
    },




          onEdit(e){
            if(this.recoData.currentRowId==''&&e!='new'){
            return;
            }
            if(e=='new'){
            this.title="新增客户"
            let random1 =Math.random().toString(36).substr(2);
            this.recoData.currentRowId=''
             this.form = {
                Name: '',
                Num:'9af7f46a-ea52-4aa3-b8c3-'+random1
              }
            }else{
            this.title="编辑客户"
            }
            this.show01=!this.show01
            },
editFuc(ValidVal){//编辑接口
let self=this


let params={'model':'customer','uuid':this.recoData.currentRowId,'Num':self.form.Num,'Name':self.form.Name,'Phone':self.form.Phone,'Manager':self.form.Manager,'Comment':self.form.Comment}
let params2={'model':'customer','uuid':this.recoData.currentRowId,'Valid':ValidVal=='ENABLE'?1:0}
let params3={'machine_code':self.optionValue,Id:'','Valid':1,'Num':self.form.Num,'Name':self.form.Name,'Phone':self.form.Phone,'Manager':self.form.Manager,'Comment':self.form.Comment}
let paramsV=ValidVal=='NEW'?params3:(ValidVal=='ENABLE'||ValidVal=='DISABLE')?params2:params
let textV=ValidVal=='NEW'?'新增成功':ValidVal=='ENABLE'?'已启用':ValidVal=='DISABLE'?'已禁用':'编辑成功'
               if(ValidVal=='ENABLE'||ValidVal=='DISABLE'){
                    if(this.recoData.currentRowId==''){
                    return;
                    }
                    let text=ValidVal=='ENABLE'?'是否确认启用？':'是否确认禁用？'
                   this.$confirm(text, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                          center: true
                    }).then(() => {
                        self.editApi(paramsV,textV)
                    })
                }
                else{
                  this.$refs.ruleForm.validate((valid) => {
      if (valid) {
                  if(self.form.Phone.length>0&&!checktel(self.form.Phone)){
                    self.$message({type: 'warn',message: '手机输入错误'});
                    return;
                }
                       if(ValidVal=='NEW'){
                        console.log("新增方法")
                        self.addApi(paramsV,textV)
                    }else{
                        console.log("编辑方法")
                        self.editApi(paramsV,textV)
                    }
                }

      });
        }

},

editApi(paramsV,textV){
        let self=this
        self.$axios.post(self.baseApiUrl+'account4/machine_data/machine_data/edit',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},
addApi(paramsV,textV){
        let self=this
        self.$axios.post(self.baseApiUrl+'account4/admin/customer/add',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},


         getRecoredList(e){
            let self=this
            self.isLoading = true;
            let recParams=self.recoData.recParams
             if(recParams.page_size>100){
                self.loadText=self.loadText2
             }else{
                self.loadText=self.loadText1
             }
             recParams.machine_code=self.optionValue
             self.$axios.get(this.baseApiUrl+'appointment/customer_list',{"params": recParams}).then(function (res) {
             console.log("resaaa")
             console.log(res)
                    self.isLoading = false;
                    if(res.data.code==1){
                        self.recoData.list=res.data.data
                        self.recoData.total=res.data.total
                    }
              })
          },



        handleSizeChange (val) {
            this.recoData.recParams.page_size = val
            this.getRecoredList()
        },
        handleCurrentChange  (val) {
            this.recoData.recParams.page = val
            this.getRecoredList()
        },

            changeCurrentRow(row, column, event) {
              if (this.recoData.currentRowId === row.uuid){
              this.recoData.currentRowId = ''
               this.form = {
                Num: '',
                Name: '',
                Spec: '',
                Type: '',
                Comment: '',
                tableData: [
                        {name:''}
                    ]
              }
              }else{
              this.recoData.currentRowId = row.uuid
              this.form=row
              }
            },
            rowStyle ({row, rowIndex}) {
              if (this.recoData.currentRowId === row.uuid) {
                // 此处返回选中行的样式对象，按需设置
                return {
                  'background-color': '#e3e8ee',
                }
              }
            },

//记录查询页 e
getoptionList(){
let self=this
 let machparam={type:2}
        self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam).then(function (res) {
            console.log("get_machine_code_list-res")
            console.log(res.data.data)
            let resdata=res.data.data
            let optionList = resdata.map(t => {
            return {
               value: t.machine_code,
                label:t.remark
               }
             })
            self.optionList=optionList
                let machparam1={type:1}
                self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam1).then(function (res) {
                    console.log("get_machine_code_list-res2")
                    console.log(res.data.data)
                    let resdata2=res.data.data
                    let optionList2 = resdata2.map(t => {
                        return {
                            value: t.machine_code,
                            label:t.remark
                           }
                     })
                    self.optionList=self.optionList.concat(optionList2)
                    self.optionValue=self.optionList[0].value
                    self.getRecoredList()

                })

})
},








        }

    }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// Customer.vue?0d2a09a2